import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_176_1624)">
      <rect y="0.5" width="18" height="18" rx="9" fill="white" />
      <path
        d="M9 18.5C13.9706 18.5 18 14.4706 18 9.5C18 4.52944 13.9706 0.5 9 0.5C4.02944 0.5 0 4.52944 0 9.5C0 14.4706 4.02944 18.5 9 18.5Z"
        fill="url(#paint0_linear_176_1624)"
      />
      <path
        d="M11.6029 11.4422L14.1492 9.97186C14.284 9.89395 14.3674 9.74916 14.3674 9.59335V6.65313C14.3674 6.49768 14.2837 6.35253 14.1492 6.27462L11.6029 4.80432C11.468 4.72642 11.3008 4.72679 11.1659 4.80432L8.61966 6.27462C8.4848 6.35253 8.40138 6.49768 8.40138 6.65313V11.9078L6.61579 12.9385L4.83019 11.9078V9.84581L6.61579 8.81502L7.79357 9.49486V8.11166L6.83407 7.55787C6.76792 7.51965 6.69222 7.49944 6.61542 7.49944C6.53862 7.49944 6.46291 7.51965 6.39713 7.55787L3.85085 9.02816C3.71599 9.10607 3.63257 9.25086 3.63257 9.40667V12.3469C3.63257 12.5023 3.71635 12.6475 3.85085 12.7254L6.39713 14.1957C6.53163 14.2732 6.6992 14.2732 6.83407 14.1957L9.38035 12.7258C9.51522 12.6479 9.59864 12.5027 9.59864 12.3473V7.09263L9.63097 7.07426L11.3842 6.06185L13.1698 7.09263V9.15458L11.3842 10.1854L10.2083 9.50626V10.8895L11.1659 11.4425C11.3008 11.5201 11.468 11.5201 11.6029 11.4425V11.4422Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_176_1624"
        x1="-3.28948"
        y1="1.97941"
        x2="15.2926"
        y2="13.3508"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A229C5" />
        <stop offset="1" stop-color="#7B3FE4" />
      </linearGradient>
      <clipPath id="clip0_176_1624">
        <rect y="0.5" width="18" height="18" rx="9" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
